export default __webpack_public_path__ + "assets/jpeg/qr_redirect_logos.c52cc15e2c3f5878a1102eda98aa4b39.jpeg";